var _rect, _path, _path2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 3,
    fill: "url(#paint0_linear_256_112)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.8718V47C0 48.6569 1.34315 50 3 50H13C14.6569 50 16 48.6569 16 47V37.4334C16 36.4546 15.5226 35.5375 14.7209 34.976L10.5587 32.0611C9.62974 31.4106 8.41337 31.3394 7.41495 31.8773L0 35.8718Z",
    fill: "url(#paint1_linear_256_112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6258 24.8031L3.15799 46.632C1.96034 47.9093 2.866 50 4.61696 50H47C48.6569 50 50 48.6569 50 47V40.1586C50 39.1265 49.4695 38.1668 48.5954 37.618L27.4097 24.3144C26.1939 23.551 24.6077 23.7558 23.6258 24.8031Z",
    fill: "url(#paint2_linear_256_112)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 5,
    fill: "url(#paint3_linear_256_112)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_256_112",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEDFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_256_112",
    x1: 8,
    y1: 31,
    x2: 8,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1CDFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_256_112",
    x1: 25,
    y1: 23,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1885FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#1885FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1885FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_256_112",
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1885FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1885FF",
    stopOpacity: 0.85
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.956dbd4d581ba0825f18af0bf81b4148.svg";
export { ForwardRef as ReactComponent };